import React from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import InvoiceForm from "../Invoice/InvoiceForm";
import api from "../../api";
import { toast } from "react-toastify";

Modal.setAppElement("#root");

const InvoiceCreateModal = ({ isOpen, onClose, onSuccess, initialData }) => {
  const { t } = useTranslation();
  const handleSave = async (formData) => {
    try {
      await api.post("/invoices", formData);
      toast.success(t("invoice.created"));
      // Succès distinct de l'annulation : onSuccess si fourni, sinon fermeture simple.
      (onSuccess || onClose)();
    } catch (err) {
      toast.error(t("invoice.createError"));
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={t("invoice.createTitle")}
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.45)",
          backdropFilter: "blur(2px)",
          zIndex: 50,
        },
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          width: "96vw",
          maxWidth: 800,         
          maxHeight: "90vh",      
          padding: 0,             
          borderRadius: 16,
          overflow: "hidden",     
          background: "#fff",
          display: "flex",
          flexDirection: "column",
          boxShadow:
            "0 10px 30px rgba(0,0,0,0.12), 0 6px 16px rgba(0,0,0,0.08)",
        },
      }}
    >
      {/* Header sticky */}
      <div
        className="sticky top-0 z-10 px-6 py-4 border-b bg-white/95 backdrop-blur flex items-center justify-between"
        style={{ position: "sticky" }}
      >
        <h2 className="text-xl font-bold text-blue-700">{t("invoice.createTitle")}</h2>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-red-600 text-2xl leading-none font-bold"
          title={t("invoice.close")}
          aria-label={t("invoice.close")}
        >
          ×
        </button>
      </div>

      {/* Corps scrollable */}
      <div className="flex-1 overflow-y-auto px-6 py-4">
        <InvoiceForm
          invoice={initialData}
          onSave={handleSave}
          onCancel={onClose}
        />
      </div>
    </Modal>
  );
};

export default InvoiceCreateModal;
